import {
  Grid,
  Typography
} from '@mui/material'
import { Address } from '../../../../components/common/Address'
import { useStyles } from './CheckinModal.styles'
import { standardProduct } from '../../utils/modalUtils'
import { createLogger } from '../../../../app/logger'
import StorefrontItems from '../../../../components/common/StorefrontItems'
import { getSelectedEntrySelector } from '../../checkinSlice'
import useAppSelector from '../../../../hooks/useAppSelector'
import { CheckinOptions } from '../../../../app/types'

// eslint-disable-next-line no-unused-vars
const logger = createLogger({
  prefix: 'EntryPanel'
})

// ==================================================================================================

export const EntryPanelLineItem = (props: { label: any, value: any }) => {
  const { classes } = useStyles()
  return (
    <Grid item xs={12} className={classes.itemBox}>
      <Typography className={classes.label}>
        {props.label}:
      </Typography>
      <Typography className={classes.value}>
        {props.value ?? props.value}
      </Typography>
    </Grid>
  )
}

export const EntryPanelLineItems = (props: { options: CheckinOptions | undefined }) => {
  const { classes } = useStyles()
  const entry = useAppSelector(getSelectedEntrySelector)
  const options = props.options
  if (!options) { return <></> }

  const checkinFields = Object.entries(options).map(([key, option]) => {
    if (!option.type || !entry) { return {} }
    const field = () => {
      switch (option.type) {
        case 'address': return <Address lite={true} className={classes.address} key={entry.entryId} />
        case 'storefront': return <StorefrontItems key={entry?.entryId} />
        case 'standardProduct': return standardProduct(entry)
        case 'customQuestion': return entry.customQuestions.find(x => x.customQuestionId === parseInt(key))?.response
        case 'thirdPartyQuestion': return entry.thirdPartyQuestions?.find(q => q.thirdPartyQuestionId === parseInt(key))?.response
        case 'regChoiceName': return entry.regChoiceName
        default: return (entry as any)[option.type]
      }
    }
    return { label: option.name, field: field() || 'N/A' }
  })

  return (
    <Grid>
      {
        checkinFields?.map((object, index) => (
          !object ? <br key={index} /> : <EntryPanelLineItem key={String(object.label)} label={object.label} value={object.field} />
        ))
      }
    </Grid>
  )
}
